import React from 'react';
import * as styles from './Switch.module.css';

interface ToggleSwitchProps {
  /** Unique id for the input */
  id?: string;
  /** The checked state (controlled by the parent) */
  checked: boolean;
  /** Callback fired when the toggle state changes */
  onChange?: (checked: boolean) => void;
  /** Disable the toggle switch */
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  id = '',
}) => {
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('handleChange!!!');
    onChange?.(event.target.checked);
  };

  return (
    <div className={styles.toggleSwitch}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleToggle}
        className={styles.toggleInput}
        disabled={disabled}
      />
      <label htmlFor={id} className={styles.slider} />
    </div>
  );
};

export default ToggleSwitch;
